module.exports = __webpack_public_path__ + "img/intro.3e2a9aec.svg";